import './testimonials.component.js';
import './roles.component.js';
import './values.component.js';
import './process.component.js';
import './locations-buttons.component.js';

import './our-sectors.component.js';
import './our-services.component.js';
import './our-team.component.js';
import './opportunities.component.js';
import './trusted.component.js';
import './feedback.component.js';
import './reviews.component.js';
import './approach.component.js';
import './similar-vacancies.component.js';
import './full-images.component.js';
import './popup-project.component.js';